export enum LandingTokenDistribution {
  tokenDistribution,
  useOfProceeds,
  companyTreasure,
  tokenSale,
  vesting,
}
